import axios from 'axios';
import { API_BASE_URL } from '../config/api-config';

/**
 * Axios instance configured for Passport SSO
 *
 * Authentication is handled via httpOnly cookies (omni_session, omni_acc)
 * set by the server. No localStorage tokens needed - cookies are sent
 * automatically with withCredentials: true.
 */
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Send cookies with every request
  timeout: 30000, // 30 second timeout
});

// Response interceptor for handling errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle unauthorized errors (401)
    if (error.response?.status === 401) {
      // Clear any legacy localStorage (cleanup)
      localStorage.removeItem('authToken');
      localStorage.removeItem('currentUser');
      localStorage.removeItem('auth-storage');

      // Only redirect if not already on auth pages or public pages
      const currentPath = window.location.pathname;
      const publicPaths = [
        '/sign-in',
        '/sign-up',
        '/profile/complete-registration',
        '/',
        '/about',
        '/features',
        '/discover',
        '/enterprise',
        '/pricing',
        '/get-started',
        '/learn',
        '/learn-more',
      ];

      const isPublicPath = publicPaths.some(
        (path) => currentPath === path || currentPath.startsWith(path)
      );

      // Also allow viewing public profiles and content
      const isPublicContent =
        currentPath.startsWith('/profile/') ||
        currentPath.startsWith('/article/') ||
        currentPath.startsWith('/discussion/');

      if (!isPublicPath && !isPublicContent) {
        window.location.href = '/sign-in';
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
